import {Component, OnInit, Input} from '@angular/core';
import {WorkingHours} from './working-hours.model';
import {GtNameValueService} from '../../services/gt-name-value.service';
import {GtNotificationService} from '../../services/gt-notification.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'gt-working-hours',
  templateUrl: './working-hours.component.html',
  styleUrls: ['./working-hours.component.scss']
})
export class WorkingHoursComponent implements OnInit {
  @Input() isCompanySetting = false;
  @Input() oname: string; // can be undefined
  @Input() login: string; // can be undefined
  @Input() canEdit = true;

  public workingHours = new Map<number, WorkingHours>();

  public editMode = false;

  public hourDropdown = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
  ];

  weekDays = [
    {key: 1, value: 'date.monday'},
    {key: 2, value: 'date.tuesday'},
    {key: 3, value: 'date.wednesday'},
    {key: 4, value: 'date.thursday'},
    {key: 5, value: 'date.friday'},
    {key: 6, value: 'date.saturday'},
    {key: 7, value: 'date.sunday'}
  ];

  constructor(private nameValueService: GtNameValueService, private notificationService: GtNotificationService) {
    this.weekDays.forEach(e => {
      this.workingHours.set(e.key, new WorkingHours(null, null, null));
    });
  }

  ngOnInit() {
    this.fetchWorkingHours().subscribe();
  }

  fetchWorkingHours(): Observable<void> {
    return this.nameValueService.getNameValueList('WorkingHours', this.isCompanySetting, this.oname, null, this.login).pipe(
      map(workinghours => {
        this.weekDays.forEach(e => {
          this.workingHours.set(e.key, new WorkingHours(null, null, null));
        });
        workinghours.forEach(e => {
          if (e.active) {
            const values = e.value.split(',');
            this.workingHours.set(Number(values[0]), new WorkingHours(values[1], values[2], values[3]));
          }
        });
      })
    );
  }

  resetEditModes() {
    this.workingHours.forEach((value, key) => {
      value.isEditable = false;
    });
  }

  save() {
    const values = [];

    this.workingHours.forEach((value, key) => {
      if (value.startHour && value.startMinute && value.duration) {
        values.push({
          value: `${key},${value.startHour},${value.startMinute},${value.duration}`,
          name: 'WorkingHours',
          active: true
        });
      }
    });

    this.nameValueService.setNameValueList('WorkingHours', values, this.isCompanySetting, this.oname, null, this.login).subscribe(
      () => {
        this.editMode = false;
      },
      e => this.notificationService.errorNotification.next(e)
    );
  }

  cancel() {
    this.fetchWorkingHours().subscribe();
    this.editMode = false;
  }

  freeDay(workingHours: WorkingHours) {
    workingHours.duration = null;
    workingHours.startMinute = null;
    workingHours.startHour = null;
  }

  toggleEditable(workingHours: WorkingHours) {
    this.editMode = true;
    workingHours.isEditable = !workingHours.isEditable;
  }
}
